import { merchantApi } from '@/config/axios'

/** 商家端 - 景区经营 API（数据范围按商家绑定景区过滤） */

export const getScenicMerchantOrderPage = (params: any) =>
  merchantApi.get({ url: '/merchant-api/scenic/merchant/order/page', params })

export const getScenicMerchantOrder = (id: number) =>
  merchantApi.get({ url: `/merchant-api/scenic/merchant/order/get?id=${id}` })

export const refundScenicMerchantOrder = (id: number, refundAmount?: number, refundReason?: string) =>
  merchantApi.put({
    url: '/merchant-api/scenic/merchant/order/refund',
    params: { id, refundAmount, refundReason }
  })

export const cancelScenicMerchantOrder = (id: number) =>
  merchantApi.put({ url: '/merchant-api/scenic/merchant/order/cancel', params: { id } })

export const getScenicMerchantSpotList = () =>
  merchantApi.get({ url: '/merchant-api/scenic/merchant/spot/list' })
